import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MAIN_APP } from "../../app/routes";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handlePostMessage = (event: any) => {
      if (typeof event.data !== "string" || !event.data.startsWith("{")) {
        return; // Ignoruj dane, które nie są prawdopodobnie JSON-em
      }

      try {
        const message = JSON.parse(event.data);

        if (message.type !== "navigate") {
          return;
        }

        const { path, params } = message;

        const queryParams = new URLSearchParams(params).toString();
        let newPath = `${MAIN_APP}/${path}`;
        if (queryParams) {
          newPath += `?${queryParams}`;
        }

        navigate(newPath);
      } catch (error) {
        console.error("Błąd podczas parsowania wiadomości:", error);
      }
    };

    window.addEventListener("message", handlePostMessage);

    return () => {
      window.removeEventListener("message", handlePostMessage);
    };
    //eslint-disable-next-line
  }, [location]);
};
